<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('menu.inspection_team') }}
      </h3>
      <div class="box-tools">
        <button
          v-if="can([Permissions.backend.team.store])"
          class="btn btn-primary btn-sm margin-r-5"
          @click="$router.push({name: 'create-team'})"
        >
          <i class="fa fa-plus" /> {{ $t('button.add_team') }}
        </button>
      </div>
    </div>
    <div class="box-body">
      <Datatable
        ref="oTable"
        url="api/backend/teams/datatable"
        table-id="team-table"
        :columns="columns"
      />
    </div>
  </div>
</template>

<script>
import Permissions from '@/permissions'
import Datatable from '@/components/Datatable'

export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('menu.inspection_team'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Datatable },
  data () {
    return {
      member: null,
      province: null,
      provinces: [],
      name: null,
      Permissions
    }
  },
  computed: {
    columns () {
      const self = this
      return [
        {
          data: 'name_km',
          name: 'name_km',
          title: self.$t('label.name'),
          render: (data, type, row) => {
            return row['name_' + this.$i18n.locale]
          }
        },
        {
          data: 'leader',
          name: 'leader',
          title: self.$t('table.leader'),
          orderable: false,
          render: (data) => {
            if (data) {
              const { first_name, last_name } = data
              return `${first_name} ${last_name}`
            } else {
              this.$t('string.na')
            }
          }
        },
        {
          data: 'members',
          name: 'members',
          title: self.$t('table.members'),
          orderable: false,
          render: (data) => {
            if (data && Array.isArray(data) && data.length) {
              return data.map(officer => officer.first_name + ' ' + officer.last_name).join(', ')
            }
            return this.$t('string.na')
          }
        },
        {
          data: 'provinces',
          name: 'provinces',
          title: self.$t('table.provinces'),
          orderable: false,
          render: (data) => {
            if (data && Array.isArray(data) && data.length) {
              return data.map(province => province['name_' + this.$i18n.locale]).join(', ')
            }
            return this.$t('string.na')
          }
        },
        {
          data: 'created_at',
          name: 'created_at',
          orderable: true,
          searchable: false,
          title: self.$t('table.createdAt'),
          render: (data) => {
            return this.getDateFormat(data)
          }
        },
        {
          data: 'action',
          name: 'action',
          orderable: false,
          searchable: false,
          title: self.$t('table.action')
        }
      ]
    }
  },
  mounted () {
    this.enabledAction()
  },
  methods: {
    enabledAction () {
      const self = this
      this.clearEventHandler([
        '.btn-edit',
        '.btn-show',
        '.btn-delete'
      ])

      $(document).on('click', '.btn-edit', function () {
        self.$router.push({
          name: 'edit-team',
          params: {
            team_uuid: $(this).attr('data-uuid')
          }
        })
      })
      $(document).on('click', '.btn-show', function () {
        self.$router.push({
          name: 'show-team',
          params: {
            team_uuid: $(this).attr('data-uuid')
          }
        })
      })
      $(document).on('click', '.btn-delete', function () {
        self.onDelete($(this).attr('data-uuid'))
      })
    },
    onDelete (team_uuid) {
      this.onConfirm({})
        .then((accept) => {
          if (accept) {
            this.$axios.delete(`${process.env.VUE_APP_API}/api/backend/teams/${team_uuid}`)
              .then(() => {
                this.showSwalSuccess()
                this.oTable.draw(true)
              })
              .catch((error) => {
                this.onResponseError(error)
              })
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
